import 'client-only';
import { Locale } from '@bts-web/utils-lokalise';
import { timeScalarToPlainString, type TimeScalar } from '../graphqlScalars';
import { timeScalarToDate } from './timeScalarToDate.client';

/**
 * Locale display for a GraphQL `Time` instant (`TimeScalar`). Runs only on the client (ADR).
 * Does not mint brands — use `timeScalarFromDateUtc` when building variables.
 */
export const convertToLocaleDateString = (
  value: TimeScalar | null | undefined,
  locale: Locale,
  options: Intl.DateTimeFormatOptions = {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  },
): string => {
  if (value == null) {
    return '';
  }

  if (timeScalarToPlainString(value) === '') {
    return '';
  }

  return timeScalarToDate(value).toLocaleDateString(locale, options);
};
